export const currencies: {
  NIS: 'ils',
  USD: 'usd',
  EUR: 'eur'
} = {
  NIS: 'ils',
  USD: 'usd',
  EUR: 'eur'
};
